
<icon class="verified-icon" name="verified" />
